"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordTextField = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
var VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
var TextField_1 = require("../TextField/TextField");
exports.PasswordTextField = function (props) {
    var _a = react_1.useState(false), showPassword = _a[0], setShowPassword = _a[1];
    var handleClickShowPassword = function () { return setShowPassword(!showPassword); };
    var handleMouseDownPassword = function (event) {
        event.preventDefault();
    };
    return (react_1.default.createElement(TextField_1.TextField, __assign({}, props, { InputProps: {
            type: showPassword ? "text" : "password",
            endAdornment: (react_1.default.createElement(core_1.InputAdornment, { style: { paddingRight: 14.5 }, position: "end" },
                react_1.default.createElement(core_1.IconButton, { "aria-label": "toggle password visibility", onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, edge: "end" }, showPassword ? (react_1.default.createElement(Visibility_1.default, { fontSize: "small" })) : (react_1.default.createElement(VisibilityOff_1.default, { fontSize: "small" }))))),
        } })));
};
